/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo — Iepazīsties, čato, draudzējies",
      "Nepareizs tālruņa numurs",
      "Get the app",
      "Turpināt ar Apple",
      "Turpināt ar Facebook",
      "Turpināt ar Google",
      "Pierakstīties",
      "Reģistrēties",
      "Lai turpinātu, lūdzu, ievadi šos simbolus zemāk redzamajā lauciņā.",
      "Turpināt",
      "Ievadi zīmes",
      "Drošības pārbaude",
      "Ielādēt no jauna",
      "Izveido jaunu paroli, kuru ir viegli iegaumēt:",
      "Mainīt",
      "Apstiprini paroli",
      "Parolei jābūt vismaz {{num}} [[characters:num@3]] garai",
      "Parole",
      "Jaunas paroles izveide",
      "Badoo – The Blog",
      "Karjera",
      "Čats",
      "Pilsētas",
      "Sīkdatņu pārvaldība",
      "Autortiesības © no 2006 līdz šim brīdim. Bumble. Visas tiesības aizsargātas.",
      "Apple un Apple logotips ir Apple Inc. piederošas preču zīmes.{{__EOL__}}Google Play ir Google LLC piederoša preču zīme.",
      "Lejupielādē",
      "Facebook",
      "Seko mums",
      "Palīdzība",
      "Instagram",
      "Valoda",
      "LinkedIn",
      "Pārskats",
      "Badoo ir daļa no Bumble Inc.",
      "Privātuma politika",
      "Safety Centre",
      "Lapas karte",
      "Mūsdienu verdzības likuma paziņojums",
      "Noteikumi un nosacījumi",
      "Twitter",
      "Ievadi savu e-pastu vai tālruņa numuru, un mēs tev atsūtīsim norādes jaunas paroles izveidei.",
      "Saņemt jaunu paroli",
      "Ievadi savu e-pastu vai tālruņa numuru",
      "Aizmirsta parole",
      "Modeļi izmantoti tikai ilustratīvos nolūkos",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Tev nav jāgaida saderība.{{__EOL__}}{{__EOL__}}Meties čatu dziļumos un izcel īstās pērles – tos dārgumus, kas patiesi saved kopā.",
      "Vēlies čatot jau tūlīt?",
      "Reģistrējoties tu piekrīti mūsu <a class=\"link\" href=\"{{terms_url}}\">Noteikumiem un nosacījumiem</a>. Uzzini, kā mēs izmantojam tavus datus, mūsu <a class=\"link\" href=\"{{privacy_url}}\">Privātuma politikā</a>",
      "Patiesi tu – lai satikšanās būtu <br />patiesi patīkama.",
      "Par drošu iepazīšanos.",
      "vai",
      "Tev jau ir konts?",
      "Reģistrējies ar e-pastu vai tālruņa numuru",
      "Atrodi tieši to, ko meklē.{{__EOL__}}Nav, ko kautrēties.",
      "Gribi tikai pačatot? Labi.{{__EOL__}}Atrast otro pusīti? Lieliski!{{__EOL__}}{{__EOL__}}Un, ja gadījumā pārdomāsi – nekādu problēmu.",
      "Vēlos satikties",
      "Vēlos jaunas attiecības",
      "Varētu pačatot",
      "Satiec cilvēkus, kuri vēlas to pašu.",
      "{{name}}, {{age}}",
      "Tava drošība mums ir pirmajā vietā.",
      "Mūsu Drošības centrs ir gudrību krātuve, kur saņemt visu nepieciešamo atbalstu drošām iepazīšanām.",
      "Apmeklē mūsu Drošības centru",
      "Drošība – vispirms,<br/>pēc tam un vienmēr.",
      "Jau no pirmā brīža es zināju, ka mums iznāks...",
      "Sākumā es nemaz nemeklēju neko nopietnu...",
      "Labākais ieteikums visiem Badoo lietotājiem – esi tāds, kāds patiesībā esi...",
      "Badoo veiksmes stāsti",
      "Lasi vēl citus veiksmes stāstus",
      "{{num}}__CUT__vērtējums",
      "Apple App Store",
      "Uzticies mums. Kopš 2006. gada esam saveduši miljoniem (un miljoniem) cilvēku.",
      "{{num}}M+__CUT__lejupielāžu",
      "{{num}}M+",
      "Google Play Store",
      "Mēs zinām, ko darām.",
      "Pieraksties ar savu e-pastu vai tālruņa numuru",
      "Ievadi savu paroli",
      "Neatceries paroli?",
      "Reģistrēties",
      "Tev nav konta?",
      "Pierakstīšanās",
      "Reģistrācija"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "rakstzīmes",
                  "rakstzīmju",
                  "rakstzīmēm",
                  "rakstzīmes",
                  "rakstzīmēs",
                  "rakstzīmēm",
                  "rakstzīmes"
            ],
            "singular": [
                  "rakstzīme",
                  "rakstzīmes",
                  "rakstzīmei",
                  "rakstzīmi",
                  "rakstzīmē",
                  "rakstzīmi",
                  "rakstzīme"
            ],
            "zero": [
                  "rakstzīmes",
                  "rakstzīmju",
                  "rakstzīmēm",
                  "rakstzīmes",
                  "rakstzīmēs",
                  "rakstzīmēm",
                  "rakstzīmes"
            ]
      },
      "day": {
            "plural": [
                  "dienas",
                  "dienu",
                  "dienām",
                  "dienas",
                  "dienās",
                  "dienām",
                  "dienas"
            ],
            "singular": [
                  "diena",
                  "dienas",
                  "dienai",
                  "dienu",
                  "dienā",
                  "dienu",
                  "diena"
            ],
            "zero": [
                  "diena",
                  "dienu",
                  "dienām",
                  "dienas",
                  "dienās",
                  "dienām",
                  "dienas"
            ]
      },
      "hour": {
            "plural": [
                  "stundas",
                  "stundu",
                  "stundām",
                  "stundas",
                  "stundās",
                  "stundām",
                  "stundas"
            ],
            "singular": [
                  "stunda",
                  "stundas",
                  "stundas",
                  "stundu",
                  "stundā",
                  "stundu",
                  "stunda"
            ],
            "zero": [
                  "stundas",
                  "stundu",
                  "stundām",
                  "stundas",
                  "stundās",
                  "stundām",
                  "stundas"
            ]
      },
      "minute": {
            "plural": [
                  "minūtes",
                  "minūšu",
                  "minūtēm",
                  "minūtes",
                  "minūtēs",
                  "minūtēm",
                  "minūtes"
            ],
            "singular": [
                  "minūte",
                  "minūtes",
                  "minūtei",
                  "minūti",
                  "minūtē",
                  "minūti",
                  "minūte"
            ],
            "zero": [
                  "minūtes",
                  "minūšu",
                  "minūtēm",
                  "minūtes",
                  "minūtēs",
                  "minūtēm",
                  "minūtes"
            ]
      },
      "month": {
            "plural": [
                  "mēneši",
                  "mēnešu",
                  "mēnešiem",
                  "mēnešus",
                  "mēnešos",
                  "mēnešiem",
                  "mēneši"
            ],
            "singular": [
                  "mēnesis",
                  "mēneša",
                  "mēnesim",
                  "mēnesi",
                  "mēnesī",
                  "mēnesi",
                  "mēnesis"
            ],
            "zero": [
                  "mēnesis",
                  "mēnešu",
                  "mēnešiem",
                  "mēnešus",
                  "mēnešos",
                  "mēnešiem",
                  "mēneši"
            ]
      },
      "second": {
            "plural": [
                  "sekundes",
                  "sekunžu",
                  "sekundēm",
                  "sekundes",
                  "sekundēs",
                  "sekundēm",
                  "sekundes"
            ],
            "singular": [
                  "sekunde",
                  "sekundes",
                  "sekundei",
                  "sekundi",
                  "sekundē",
                  "sekundi",
                  "sekunde"
            ],
            "zero": [
                  "sekundes",
                  "sekunžu",
                  "sekundēm",
                  "sekundes",
                  "sekundēs",
                  "sekundēm",
                  "sekundes"
            ]
      },
      "year": {
            "plural": [
                  "gadi",
                  "gadu",
                  "gadiem",
                  "gadus",
                  "gados",
                  "gadiem",
                  "gadi"
            ],
            "singular": [
                  "gads",
                  "gada",
                  "gadam",
                  "gadu",
                  "gadā",
                  "gadu",
                  "gads"
            ],
            "zero": [
                  "gadi",
                  "gadu",
                  "gadiem",
                  "gadus",
                  "gados",
                  "gadiem",
                  "gadi"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
